import { Checkbox, FormControlLabel, Grid } from "@mui/material";
import HlxButton from "component/commonComponents/button/button";
import SelectBox from "component/commonComponents/selectBox";
import Textbox from "component/commonComponents/Textbox";
import React, { useEffect, useState } from 'react';
import { StyledAddNewFeature } from "./addNewFeature.style";

export interface IAddNewFeatureProps {
  isType: string;
  detailFeature?: object;
  onOpenPrompt: (dataAddNewFeature?: any, isAddFeature?: boolean) => void;
  onCloseSideSheet: () => void;
  listParentKey: any[];
};

const AddNewFeature = (props: IAddNewFeatureProps) => {
  const { isType, detailFeature, listParentKey, onOpenPrompt, onCloseSideSheet } = props;
  const defaultValueFeature = {
    name: "",
    key: "",
    enabled: true,
    parentKey: "",
  };

  const isAddFeature = isType === 'ADD';

  const [dataNewFeature, setDataNewFeature] = useState<any>(!!detailFeature && Object.keys(detailFeature).length > 0 ? detailFeature : defaultValueFeature);
  const [validationFields, setValidationFields] = useState<any>({});
  const [msgError, setMsgError] = useState<string>('');

  useEffect(() => {
    setValidationFields({
      name: true,
      key: true
    });
  }, []);

  const validateField = (fieldName: string) => {
    setValidationFields({
      ...validationFields,
      [fieldName]: !!dataNewFeature[fieldName]
    });
  };

  const handleChange = (objChange: {fieldName: string, value: string}) => {
    setDataNewFeature({
      ...dataNewFeature,
      [objChange.fieldName]: objChange.value
    });
  };

  const handleSubmitFeature = () => {
    let isValid = true, validFields = {};
    let validateKeyField = true;

    Object.keys(validationFields).forEach(ele => {
      const isCheckExistKey = isAddFeature && !!dataNewFeature[ele] && listParentKey.filter((k: any) => k.value === dataNewFeature[ele]).length > 0;

      if (!dataNewFeature[ele] || (ele === 'key' && isCheckExistKey)) {
        isValid = false;
      }

      if (ele === 'key' && isAddFeature) {
        validateKeyField = !!dataNewFeature[ele] && listParentKey.filter((k: any) => k.value === dataNewFeature[ele]).length === 0 ? true : false;

        setMsgError(isCheckExistKey ? 'This key already exists!' : '');

      }

      validFields = {
        ...validFields,
        [ele]: !!dataNewFeature[ele],
        key: validateKeyField
      };

    });

    setValidationFields({
      ...validationFields,
      ...validFields
    });

    if (isValid) {
      onOpenPrompt(dataNewFeature, isAddFeature);
    }
  };

  const enableButton = !!dataNewFeature['key'] && !!dataNewFeature['name'];

  return (
    <>
      <StyledAddNewFeature>
        <h3 className="title">{isAddFeature ? 'Add New Feature' : 'Update Feature'}</h3>
        <div className="form-detail">
          <Grid container>
            <Grid item xs={12} className="mt-20">
              <Textbox
                id="feature-name"
                label="Feature Name"
                labelSize="small"
                type="text"
                name="name"
                placeholder="Feature name"
                boldLabel={true}
                value={dataNewFeature.name}
                error={!validationFields.name}
                onChange={(e: any) => handleChange({fieldName: 'name', value: e.target.value})}
                onBlur={() => validateField('name')}
                required
              />
            </Grid>

            <Grid item xs={12} className="mt-20">
              <Textbox
                id="key"
                label="Key"
                labelSize="small"
                type="text"
                name="key"
                placeholder="Key"
                errorMessage={msgError}
                boldLabel={true}
                value={dataNewFeature.key}
                error={!validationFields.key}
                onChange={(e: any) => handleChange({fieldName: 'key', value: e.target.value})}
                onBlur={() => validateField('key')}
                required
                disabled={isAddFeature ? false : true}
              />
            </Grid>

            <Grid item xs={12} className="mt-20">
              <SelectBox
                id="parent-key"
                name="parentKey"
                label="Parent Key"
                required={false}
                value={listParentKey?.find((parKey: {value: string}) => parKey.value === dataNewFeature.parentKey) || {name: "", value: ""}}
                placeholder="Select option..."
                handleChange={(e: any, selected: {value: string}) => handleChange({fieldName: 'parentKey', value: selected.value})}
                error={false}
                variant="outlined"
                options={listParentKey}
                disableClearable
                boldLabel={true}
                disabled={isAddFeature ? false : true}
              />
            </Grid>
          </Grid>

          <FormControlLabel
            value={dataNewFeature.enabled}
            control={
              <Checkbox
                checked={dataNewFeature.enabled}
                onChange={() => {
                  setDataNewFeature({
                    ...dataNewFeature,
                    enabled: !dataNewFeature.enabled
                  });
                }}
              />
            }
            label="Active"
          />

          <div className="group-button">
            <HlxButton
              label={`${isAddFeature ? 'ADD' : 'UPDATE'}`}
              onClick={handleSubmitFeature}
              disabled={!enableButton}
            />

            <HlxButton
              label="Cancel"
              onClick={onCloseSideSheet}
            />
          </div>
        </div>
      </StyledAddNewFeature>
    </>
  );
};

export default AddNewFeature;
